import React, {useState, useRef, useLayoutEffect} from "react";
import ReactDOM from "react-dom";
import "./tooltip.css";

const Tooltip = ({
    title,
    description,
    children,
    position = "top",
    variant = "default"
}) => {
    const [visible, setVisible] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);

    const hasContent = title || description;

    useLayoutEffect(() => {
        if (visible && triggerRef.current && tooltipRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();

            let top, left;
            switch (position) {
                case "top":
                    top = rect.top + window.scrollY - tooltipRect.height - 8;
                    left = rect.left + window.scrollX + rect.width / 2 - tooltipRect.width / 2;
                    break;
                case "bottom":
                    top = rect.bottom + window.scrollY + 8;
                    left = rect.left + window.scrollX + rect.width / 2 - tooltipRect.width / 2;
                    break;
                case "left":
                    top = rect.top + window.scrollY + rect.height / 2 - tooltipRect.height / 2;
                    left = rect.left + window.scrollX - tooltipRect.width - 8;
                    break;
                case "right":
                    top = rect.top + window.scrollY + rect.height / 2 - tooltipRect.height / 2;
                    left = rect.right + window.scrollX + 8;
                    break;
                default:
                    top = rect.top + window.scrollY - tooltipRect.height - 8;
                    left = rect.left + window.scrollX + rect.width / 2 - tooltipRect.width / 2;
            }

            setCoords({ top, left });
        }
    }, [visible, position]);

    const showTooltip = () => hasContent && setVisible(true);
    const hideTooltip = () => setVisible(false);

    return (
        <>
        <span
            ref={triggerRef}
            className="tooltip-trigger"
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            onFocus={showTooltip}
            onBlur={hideTooltip}
        >
            {children}
        </span>
            {visible &&
                ReactDOM.createPortal(
                    <div
                        ref={tooltipRef}
                        className={`tooltip-text tooltip-${position} tooltip-${variant}`}
                        style={{
                            top: `${coords.top}px`,
                            left: `${coords.left}px`,
                            position: "absolute"
                        }}
                    >
                        {variant === "default" ? (
                            <>{title}</>
                        ) : (
                            <div className="tooltip-content">
                                <div className="tooltip-title">{title}</div>
                                {description && (
                                    <div className="tooltip-description">{description}</div>
                                )}
                            </div>
                        )}
                        <div className={`tooltip-arrow arrow-${position}`}></div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default Tooltip;
